import axios from 'axios';

const rawBackendUrl = (process.env.REACT_APP_BACKEND_URL || '').trim().replace(/\/$/, '');
const BACKEND_URL = rawBackendUrl.replace(/\/api$/, '');
const API = `${BACKEND_URL}/api`;

/** Platform owner agency directory — same route as AgencyListPage. */
export const PLATFORM_AGENCIES_PATH = '/owner-console/agencies';
export const PLATFORM_AGENCIES_URL = `${API}${PLATFORM_AGENCIES_PATH}`;

const MAX_PLATFORM_AGENCIES_LIMIT = 100;

export function normalizePlatformAgenciesResponse(data) {
  if (!data) return [];
  if (Array.isArray(data)) return data;
  if (Array.isArray(data.items)) return data.items;
  if (Array.isArray(data.agencies)) return data.agencies;
  return [];
}

export function getPlatformAgencyId(agency) {
  return agency?.agency_id || agency?.id || '';
}

export function getPlatformAgencyLabel(agency) {
  return agency?.name || agency?.agency_name || getPlatformAgencyId(agency) || 'Agency';
}

export function isSelectablePlatformAgency(agency) {
  const status = String(agency?.status || '').toLowerCase();
  const deletion = String(agency?.deletion_status || '').toLowerCase();
  return status !== 'pending_deletion' && deletion !== 'pending_deletion';
}

export async function fetchPlatformAgencies({
  token,
  limit = MAX_PLATFORM_AGENCIES_LIMIT,
  search,
  status,
  excludePendingDeletion = true,
} = {}) {
  const params = new URLSearchParams();
  if (search) params.set('search', search);
  if (status) params.set('status', status);
  params.set('limit', String(Math.min(Math.max(limit, 1), MAX_PLATFORM_AGENCIES_LIMIT)));

  const response = await axios.get(`${PLATFORM_AGENCIES_URL}?${params.toString()}`, {
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });

  let agencies = normalizePlatformAgenciesResponse(response.data);
  if (excludePendingDeletion) {
    agencies = agencies.filter(isSelectablePlatformAgency);
  }
  return {
    agencies,
    total: response.data?.total ?? agencies.length,
  };
}
